import { Component, ErrorInfo } from 'react';

export class ErrorBoundary extends Component<{
    fallback: () => React.ReactNode;
}> {
    state = { hasError: false };

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error(error, errorInfo);
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback();
        }

        return this.props.children;
    }
}
